import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-success-alert-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './success-alert-modal.html',
  styleUrl: './success-alert-modal.scss'
})
export class SuccessAlertModalComponent {
  @Input() visible = false;
  @Input() title = 'Operación exitosa';
  @Input() message = 'La información se guardó correctamente.';
  @Input() variant: 'success' | 'info' = 'success';

  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
